export default "__VITE_ASSET__nvZT3kmn__"